import React, { useState } from "react";

const FAQAccordion = () => {
  const faqs = [
    {
      question: "What is this Solar Directory?",
      answer:
        "The Solar Directory is a comprehensive platform that connects users with solar manufacturers, retailers, distributors, installers, and other solar-related services worldwide.",
    },
    {
      question: "Who can use this directory?",
      answer:
        "This directory is for anyone interested in solar energy, including individuals, businesses, and organizations looking for products, services, or partnerships in the solar industry.",
    },
    {
      question: "Is the directory free to use?",
      answer:
        "Yes, the directory is free for users to search and browse. However, premium features or priority listings may incur additional costs.",
    },
    {
      question: "How do I search for solar businesses or services?",
      answer:
        "Use the search box on the homepage. Select your country and specify what you’re looking for (e.g., manufacturers, installers, or products). The results will show listings matching your criteria.",
    },
    {
      question: "Can I filter search results?",
      answer:
        "Yes, you can filter results by name, city, and specific services offered.",
    },
    {
      question: "What if I can’t find what I’m looking for?",
      answer:
        "Click on the “Add Listing” button on the homepage. Fill in the required details, including business name, category, location, and contact information, and submit.",
    },
    {
      question: "Are there any fees for adding a listing?",
      answer:
        "Basic listings are free. However, premium features like priority visibility or enhanced profiles may involve a fee.",
    },
    {
      question: "How long does it take for my listing to go live?",
      answer:
        "Listings are typically reviewed and approved within 48 hours. You’ll be notified via email once your listing is live.",
    },
    {
      question: "Can I edit my listing after submission?",
      answer:
        "Yes, log in to your account to update or modify your listing at any time.",
    },
    {
      question: "Can I advertise my solar products/services on the directory?",
      answer:
        "Yes, we offer advertising opportunities. Please contact us for packages and pricing.",
    },
    {
      question: "What if I can’t find what I’m looking for?",
      answer:
        "Click on the “Add Listing” button on the homepage. Fill in the required details, including business name, category, location, and contact information, and submit.",
    },
    {
      question: "Are there any fees for adding a listing?",
      answer:
        "Basic listings are free. However, premium features like priority visibility or enhanced profiles may involve a fee.",
    },
    {
      question: "How long does it take for my listing to go live?",
      answer:
        "Listings are typically reviewed and approved within 48 hours. You’ll be notified via email once your listing is live.",
    },
    {
      question: "Can I edit my listing after submission?",
      answer:
        "Yes, log in to your account to update or modify your listing at any time.",
    },
    {
      question: "Can I advertise my solar products/services on the directory?",
      answer:
        "Yes, we offer advertising opportunities. Please contact us for packages and pricing.",
    },
    {
      question: "How can I partner with the Solar Directory?",
      answer:
        "We welcome partnerships with solar organizations, manufacturers, and NGOs. Reach out via our contact form to discuss collaboration opportunities.",
    },
    {
      question: "Do I need to create an account to use the directory?",
      answer:
        "No, you can browse and search without an account. However, creating an account allows you to save favorite listings and manage your submissions.",
    },
    {
      question: "How do I create an account?",
      answer:
        "Click the “Register” button in the header and fill in your details. Once registered, you can log in to access additional features.",
    },
    {
      question: "Are all listings verified?",
      answer:
        "We strive to ensure all listings are accurate and verified. However, we recommend contacting businesses directly to confirm specific details.",
    },
    {
      question: "Can I report inaccurate or fraudulent listings?",
      answer:
        "Yes, click the “Report Listing” button on the Details Page or contact our support team with the listing details.",
    },
    {
      question: "What if I encounter an issue while using the directory?",
      answer:
        "If you experience any technical issues, contact our support team via the contact us.",
    },
    {
      question: "Does the directory work on mobile devices?",
      answer:
        "Yes, the directory is fully optimized for mobile and tablet devices, ensuring a seamless experience on the go.",
    },
    {
      question: "How is my personal information protected?",
      answer:
        "We prioritize user privacy. Your data is stored securely and used only for directory-related purposes. Please refer to our Privacy Policy for more details.",
    },
    {
      question: "Will my contact information be visible to others?",
      answer:
        "Only the information you provide for your listing will be visible to users. Private data, such as your account details, remains secure.",
    },
  ];

  const [openIndices, setOpenIndices] = useState([]);

  const toggleAccordion = (index) => {
    if (openIndices.includes(index)) {
      setOpenIndices(openIndices.filter((i) => i !== index));
    } else {
      setOpenIndices([...openIndices, index]);
    }
  };

  return (
    <div className="max-w-3xl lg:max-w-5xl px-10 sm:px-6 md:px-10 lg:px-8 xl:px-12 mx-auto bg-white rounded-lg font-inter">
      {faqs.map((faq, index) => (
        <div key={index} className="faq-item border-b py-2">
          <button
            onClick={() => toggleAccordion(index)}
            className="w-full text-left py-3 flex justify-between items-center text-sm sm:text-lg 2xl:text-xl px-4"
          >
            {faq.question}
            <span className="ml-2">{openIndices === index ? "-" : "+"}</span>
          </button>
          <div
            className={`transition-all duration-700 ease-in-out overflow-hidden px-4 ${
              openIndices.includes(index) ? "max-h-40" : "max-h-0"
            }`}
          >
            <p className="mt-2 text-[#4E5562] pb-2 text-sm sm:text-base md:text-base lg:text-base 2xl:text-lg">
              {faq.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;